import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum CourseStates {
    DRAFT = 'draft',
    ACTIVE = 'active'
}

export namespace CourseStates {
    type Data = { text: string, color: string };

    export const Record: Record<CourseStates, Data> = {
        [CourseStates.ACTIVE]: {text: 'Aktiver Kurs', color: 'success'},
        [CourseStates.DRAFT]: {text: 'Kursentwurf', color: 'grey'},
    }

    export const Items = mapRecordToItems(Record);
}
